import React, { Component } from 'react';

import './DampsDatabase.css';

import { background_10, services9 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Copy from '../../components/Copy/Copy';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}
interface State{
}

export default class DampsDatabase extends Component<Props,State>{
    render(){
        return (
        <Page 
            id="damps-database"
            banner={{
                title: "Damps Database",
                bannerImage: background_10,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('Damps Database') }</title>
                <meta 
                    name="description" 
                    content="The DAMPS database information"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <h1 className="title-3">DAMPS FTP</h1>
                    <br/>
                    <br/>
                    <div className="info-field">
                        <label><i className="fas fa-desktop"/> Host</label>
                        <div className="info-value-wrapper">
                            <div className="info-value">
                                ftp.damps.info/db_dump
                            </div>
                            <Copy className="info-copy" copy={"ftp.damps.info/db_dump"}/>
                        </div>
                    </div>

                </div>
            </div>
        </Page>
        );
    }

};
